export default "__VITE_ASSET__10afd03d__"